import { render } from "./MinorCountdown.vue?vue&type=template&id=63a07bd0&scoped=true"
import script from "./MinorCountdown.vue?vue&type=script&lang=js"
export * from "./MinorCountdown.vue?vue&type=script&lang=js"

import "./MinorCountdown.vue?vue&type=style&index=0&id=63a07bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a07bd0"]])

export default __exports__